/** Lucide icon per navigation id (kept out of navigation.ts so that module stays React-free). */
import {
  Activity,
  BarChart3,
  Building2,
  ClipboardCheck,
  Dices,
  FileText,
  Gift,
  LayoutDashboard,
  LifeBuoy,
  Package,
  ScrollText,
  Settings,
  Trophy,
  Users,
  Wallet,
  type LucideIcon,
} from 'lucide-react';

export const NAV_ICONS: Record<string, LucideIcon> = {
  dashboard: LayoutDashboard,
  lotteries: Dices,
  draws: Activity,
  reports: FileText,
  winners: Trophy,
  claims: ClipboardCheck,
  support: LifeBuoy,
  fulfillment: Package,
  engagement: BarChart3,
  finance: Wallet,
  audience: Users,
  catalog: Gift,
  'sponsor-reports': Building2,
  audit: ScrollText,
  settings: Settings,
};
